// extracted by mini-css-extract-plugin
export default {"faqContainer":"FAQ_faqContainer__RramL","faqList":"FAQ_faqList__-qOEM","faqItem":"FAQ_faqItem__77Soo","videoContainer":"FAQ_videoContainer__xwnkO"};